// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MessageTwoToneSvg from "@ant-design/icons-svg/es/asn/MessageTwoTone";
import AntdIcon from '../components/AntdIcon';

var MessageTwoTone = function MessageTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MessageTwoToneSvg
  }));
};

MessageTwoTone.displayName = 'MessageTwoTone';
export default /*#__PURE__*/React.forwardRef(MessageTwoTone);